/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimulationResponseDTO
 */
export interface SimulationResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof SimulationResponseDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationResponseDTO
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationResponseDTO
     */
    numberOfSpots?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationResponseDTO
     */
    remainingSpots?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationResponseDTO
     */
    firstChoiceNumber?: number;
}

export function SimulationResponseDTOFromJSON(json: any): SimulationResponseDTO {
    return SimulationResponseDTOFromJSONTyped(json, false);
}

export function SimulationResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulationResponseDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'numberOfSpots': !exists(json, 'numberOfSpots') ? undefined : json['numberOfSpots'],
        'remainingSpots': !exists(json, 'remainingSpots') ? undefined : json['remainingSpots'],
        'firstChoiceNumber': !exists(json, 'firstChoiceNumber') ? undefined : json['firstChoiceNumber'],
    };
}

export function SimulationResponseDTOToJSON(value?: SimulationResponseDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'numberOfSpots': value.numberOfSpots,
        'remainingSpots': value.remainingSpots,
        'firstChoiceNumber': value.firstChoiceNumber,
    };
}

